import { useCallback, useState } from 'react';

export const useNotifications = () => {
  const [permissionDenied, setPermissionDenied] = useState(
    'Notification' in window && Notification.permission === 'denied'
  );

  const requestPermission = useCallback(async () => {
    if (!('Notification' in window)) {
      console.log('Notifications not supported');
      return false;
    }

    const permission = await Notification.requestPermission();
    const granted = permission === 'granted';
    setPermissionDenied(!granted && permission === 'denied');
    return granted;
  }, []);

  const sendNotification = useCallback((title, options = {}) => {
    if (Notification.permission !== 'granted') return;
    if (navigator.serviceWorker?.controller) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification(title, {
          icon: '/icon-192x192.png',
          badge: '/badge-72x72.png',
          requireInteraction: true,
          ...options
        });
      });
    } else {
      new Notification(title, options);
    }
  }, []);

  const scheduleNotification = useCallback((delay, title, options) => {
    setTimeout(() => {
      sendNotification(title, options);
    }, delay);
  }, [sendNotification]);

  return { requestPermission, sendNotification, scheduleNotification, permissionDenied };
};
